/* eslint-disable react/boolean-prop-naming */

import type { FC } from 'react';
import Editor from '@monaco-editor/react';
import { editor, KeyCode, KeyMod } from 'monaco-editor';
import { editorOptions } from '@/modules/CodeEditor/CodeEditor.data.ts';

const EXTENSION_TO_LANGUAGE: Record<string, string> = {
    yaml: 'yaml',
    yml: 'yaml',
    json: 'json',
    md: 'markdown',
    py: 'python',
    js: 'javascript',
    ts: 'typescript',
    jinja: 'handlebars',
    j2: 'handlebars',
    nsl: 'twig',
    nslg: 'handlebars',
    sh: 'shell'
};

const detectLanguage = (filePath: string): string => {
    const extension = filePath.split('.').pop()?.toLowerCase() ?? '';
    return EXTENSION_TO_LANGUAGE[extension] ?? 'plaintext';
};

interface FileEditorProps {
    filePath: string;

    versionId: string;
    value: string;
    readOnly: boolean;
    onChange: (value: string | undefined) => void;
    onSave: () => void;
}

const FileEditor: FC<FileEditorProps> = ({
    filePath,
    versionId,
    value,
    readOnly,
    onChange,
    onSave
}) => {
    const modelPath = `${versionId}/${filePath}`;
    const handleMount = (instance: editor.IStandaloneCodeEditor) => {
        if (!readOnly) {
            instance.addCommand(KeyMod.CtrlCmd | KeyCode.KeyS, onSave);
        }
    };

    const handleChange = (next: string | undefined) => {
        if (next === value) {
            return;
        }
        onChange(next);
    };

    return (
        <div className="relative block h-full w-full">
            <Editor
                keepCurrentModel
                height="100%"
                language={detectLanguage(filePath)}
                options={{ ...editorOptions, readOnly }}
                path={modelPath}
                theme="newo"
                value={value}
                onChange={handleChange}
                onMount={handleMount}
            />
        </div>
    );
};

export default FileEditor;
